import type { McpServerSpec } from "@p0security/shared/types/agentic/mcp";
import { ValidationError } from "@p0security/shared/types/error";

const INSTANCE_PLACEHOLDER = "{instance}";

/** Whether `instance` is a valid value for the server's instance. True when
 * the server takes no instance. */
export const isValidInstance = (
  spec: McpServerSpec,
  instance: string | undefined
) =>
  !spec.instance ||
  (instance !== undefined &&
    spec.instance.pattern.exec(instance)?.[0] === instance);

/** Puts the install's instance into the server's URL.
 *
 * @throws ValidationError when the server takes an instance and `instance`
 * is missing or does not match the server's pattern
 */
export const withInstance = <S extends McpServerSpec>(
  spec: S,
  instance: string | undefined
): S => {
  if (!spec.instance || spec.type !== "external") return spec;
  if (!isValidInstance(spec, instance)) {
    throw new ValidationError(
      "definition.instance",
      { instance },
      `${spec.instance.label} is not valid: ${spec.instance.description}`
    );
  }
  // The pattern can allow characters that are not safe in a URL
  const url = spec.url.replace(
    INSTANCE_PLACEHOLDER,
    encodeURIComponent(instance ?? "")
  );
  return { ...spec, url };
};
